import { useMemo, useState } from "react";
import { SciStatGrid, SciTextArea } from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { getLocale } from "@/paraglide/runtime";
import { gcContent } from "../lib/gc-content";

export function GcContentCalc() {
  const locale = getLocale();
  const [seq, setSeq] = useState("");
  const r = useMemo(() => gcContent(seq), [seq]);
  const pct = (n: number) =>
    `${n.toLocaleString(locale, { maximumFractionDigits: 2 })}%`;

  return (
    <div className="sci-card rounded-2xl p-6 sm:p-8">
      <SciTextArea
        id="gc-input"
        label={m.gc_input_label()}
        value={seq}
        placeholder={m.gc_input_placeholder()}
        onChange={setSeq}
      />

      {r.length > 0 ? (
        <>
          <div className="sci-result-zone mt-5 flex items-baseline justify-between gap-4 rounded-xl px-5 py-4">
            <span className="text-sm font-medium text-muted-foreground">
              {m.gc_result_label()}
            </span>
            <span
              data-testid="gc-result"
              className="sci-result font-display text-3xl font-bold sm:text-4xl"
            >
              {pct(r.gcPercent)}
            </span>
          </div>
          <SciStatGrid
            items={[
              {
                label: m.gc_stat_length(),
                value: r.length.toLocaleString(locale),
              },
              { label: m.gc_stat_at(), value: pct(r.atPercent) },
              { label: "G", value: r.g.toLocaleString(locale) },
              { label: "C", value: r.c.toLocaleString(locale) },
              { label: "A", value: r.a.toLocaleString(locale) },
              { label: "T / U", value: r.t.toLocaleString(locale) },
            ]}
          />
        </>
      ) : (
        <p className="mt-5 text-sm text-muted-foreground">
          {m.gc_hint_empty()}
        </p>
      )}
    </div>
  );
}
